/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Discord_AlreadyInputs */



/**
* | output |
* | --- |
* | "Discord is already linked to this account." |
*
* @param {Profile_Discord_AlreadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_discord_already = /** @type {((inputs?: Profile_Discord_AlreadyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Discord_AlreadyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Discord est déjà lié à ce compte.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Discord ya está vinculado a esta cuenta.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Discord já está vinculado a esta conta.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Discord è già collegato a questo account.")
	return /** @type {LocalizedString} */ ("Discord is already linked to this account.")
});